function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigit3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3.504688mm",
    height: "5.9460902mm",
    viewBox: "0 0 3.504688 5.9460902",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19.412945,-96.60467)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 19.747322,101.48985 q 0.167969,0.14062 0.386719,0.21093 0.222656,0.0703 0.492187,0.0703 0.628907,0 1.039063,-0.30079 0.410156,-0.30078 0.410156,-0.75 0,-0.39453 -0.289062,-0.60937 -0.289063,-0.214845 -0.941407,-0.300782 -0.109375,-0.01563 -0.292968,-0.03125 -0.46875,-0.03906 -0.46875,-0.25 0,-0.207031 0.386718,-0.292969 0.05469,-0.01172 0.08594,-0.01953 0.757812,-0.164063 1.097656,-0.414063 0.339844,-0.253906 0.339844,-0.648437 0,-0.351563 -0.273438,-0.558594 -0.273437,-0.210937 -0.734375,-0.210937 -0.296875,0 -0.535156,0.101562 -0.238281,0.101563 -0.433594,0.308594 -0.136718,-0.09766 -0.203125,-0.199219 -0.06641,-0.101562 -0.06641,-0.21875 0,-0.285156 0.359375,-0.476562 0.359375,-0.195313 0.925781,-0.195313 0.765625,0 1.234375,0.371094 0.472657,0.371094 0.472657,0.964844 0,0.503906 -0.355469,0.859375 -0.351563,0.355468 -1,0.5 0.730469,0.152343 1.082031,0.46875 0.351563,0.316407 0.351563,0.820307 0,0.74219 -0.691407,1.25391 -0.691406,0.50781 -1.726562,0.50781 -0.441406,0 -0.664063,-0.11328 -0.222656,-0.11719 -0.222656,-0.34375 0,-0.0977 0.05469,-0.21875 0.05859,-0.12109 0.179687,-0.28515 z",
    style: {
      fontSize: 8,
      fontFamily: "'Maiandra GD'",
      InkscapeFontSpecification: "'Maiandra GD, Normal'",
      stroke: "#000000",
      strokeWidth: 0.2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigit3);
export default __webpack_public_path__ + "static/media/digit-3.58000906f7ba9d47e47630a7b25182dc.svg";
export { ForwardRef as ReactComponent };